/* SLB @ tradehou.se brand JS: window-title and favicon override.
 * Runs on every desk + website page load.
 */
(function () {
  const FAVICON = "/assets/erp_custom/images/favicon.svg";
  const APPLE_TOUCH = "/assets/erp_custom/images/favicon-180.png";
  const TITLE_SUFFIX = "SLB @ tradehou.se";

  // ---------------------------------------------------------------------
  // Self-heal stale client caches.
  //
  // Frappe registers a PWA service worker that pre-caches the desk shell and
  // bundles. After a deploy the server serves fresh, content-hashed assets and
  // we FLUSHALL redis — but an active service worker keeps serving the OLD
  // cached files, so users stay "stuck on the old build" until they manually
  // clear site data. Nuke any service worker + CacheStorage on load so every
  // client repairs itself on the first visit after a deploy. Cheap no-op when
  // nothing is registered; the page keeps using already-loaded assets and the
  // next navigation comes straight from the network.
  // ---------------------------------------------------------------------
  function killStaleClientCaches() {
    try {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (regs) {
          regs.forEach(function (r) {
            r.unregister();
          });
        }).catch(function () {});
      }
      if (window.caches && caches.keys) {
        caches.keys().then(function (keys) {
          keys.forEach(function (k) {
            caches.delete(k);
          });
        }).catch(function () {});
      }
    } catch (e) {
      /* never let cache cleanup break the page */
    }
  }
  killStaleClientCaches();

  function ensureLink(rel, href, type) {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    if (type) link.type = type;
    link.href = href;
  }

  function applyBranding() {
    ensureLink("icon", FAVICON, "image/svg+xml");
    ensureLink("shortcut icon", FAVICON, "image/svg+xml");
    ensureLink("apple-touch-icon", APPLE_TOUCH);

    if (document.title && !document.title.includes(TITLE_SUFFIX)) {
      const head = document.title.replace(/ - ERPNext$/, "").trim();
      document.title = head ? `${head} | ${TITLE_SUFFIX}` : TITLE_SUFFIX;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyBranding);
  } else {
    applyBranding();
  }

  // The desk swaps document.title dynamically — observe and re-stamp.
  const observer = new MutationObserver(applyBranding);
  const target = document.querySelector("title");
  if (target) observer.observe(target, { childList: true });

  // ---------------------------------------------------------------------
  // Kill the upstream "About" dialog that exposes Frappe / ERPNext links.
  // The navbar help item is already dropped via Navbar Settings, but
  // neutralise the underlying functions too so nothing can re-trigger it.
  // ---------------------------------------------------------------------
  function removeHelpMenu() {
    document
      .querySelectorAll(".dropdown-help, .dropdown-navbar-help, .navbar-help")
      .forEach(function (el) {
        el.remove();
      });
  }

  function scrubAbout() {
    if (typeof frappe === "undefined" || !frappe) return false;
    const noop = function () {};
    if (frappe.ui) {
      if (frappe.ui.toolbar) {
        frappe.ui.toolbar.show_about = noop;
        // Kill the help-menu setup so it never re-renders the doc/forum links.
        frappe.ui.toolbar.setup_help = noop;
      }
      if (frappe.ui.misc) frappe.ui.misc.about = noop;
    }
    removeHelpMenu();
    return true;
  }

  if (!scrubAbout()) {
    let tries = 0;
    const timer = setInterval(function () {
      if (scrubAbout() || ++tries > 50) clearInterval(timer);
    }, 200);
  }

  // The navbar can render after our first pass; keep the help menu gone.
  if (document.body) {
    new MutationObserver(removeHelpMenu).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
